import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false); // Αν το banner είναι ορατό
  const [hideBanner, setHideBanner] = useState(false); // Αν το banner εξαφανίζεται

  useEffect(() => {
    // 🔍 Έλεγχος αν υπάρχει ήδη το cookie "cookies_accepted=true"
    const cookiesAccepted = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cookies_accepted='))
      ?.split('=')[1] === 'true';

    if (!cookiesAccepted) {
      // Αν ΔΕΝ έχει γίνει αποδοχή, δείξε το banner
      setTimeout(() => {
        console.log('No cookies found. Showing banner.');
        setShowBanner(true);
      }, 100);
    } else {
      console.log('Cookies already accepted. Not showing banner.');
    }
  }, []);

  const acceptCookies = () => {
    console.log('Cookies accepted. Hiding banner...');
    // 📝 Αποθήκευση συγκατάθεσης για 1 χρόνο
    document.cookie = 'cookies_accepted=true; max-age=31536000; path=/';
    setHideBanner(true);
    setTimeout(() => {
      setShowBanner(false);
    }, 700); // να ταιριάζει με το CSS transition
  };

  // Αν δεν πρέπει να εμφανιστεί καθόλου
  if (!showBanner && !hideBanner) {
    return null;
  }

  return (
    <div
      className={`cookie-consent-banner ${
        showBanner && !hideBanner ? 'show' : ''
      } ${hideBanner ? 'hide' : ''}`}
    >
      <div className="cookie-content">
        <p>
          Χρησιμοποιούμε cookies για να διασφαλίσουμε την καλύτερη εμπειρία στο
          site μας. <a href="/cookies-policy">Μάθετε περισσότερα</a>
        </p>
        <button className="accept-btn" onClick={acceptCookies}>
          Συμφωνώ
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
